import { useMemo } from 'react';

export const useIsDarkmode = () => {
    return useMemo(() => window.matchMedia('(prefers-color-scheme: dark)').matches, []);
};
